import { isPostalCode } from 'validator';
import * as Yup from 'yup';

import { logError } from '@savgroup-front-common/configuration/appInsights/AppInsights';
import { COUNTRY_CODES } from '@savgroup-front-common/constants';
import {
  globalMessages,
  isAddress,
  isEmail,
  isValidPhoneNumber,
} from '@savgroup-front-common/core/helpers';
import { UnknownOption } from '@savgroup-front-common/types';
import { AutocompleteOption } from '@savgroup-front-common/types';

import messages from './messages';

const OnboardingFormSchema = () => {
  return Yup.object().shape({
    email: Yup.string()
      .required(globalMessages.form.required)
      .test('is-email', globalMessages.form.invalidEmail, (value) => {
        return isEmail(value);
      }),
    lastName: Yup.string().required(globalMessages.form.required),
    firstName: Yup.string().required(globalMessages.form.required),
    companyName: Yup.string().required(globalMessages.form.required),
    cName: Yup.string().required(globalMessages.form.required),
    phone: Yup.string()
      .required(globalMessages.form.required)
      .test(
        'validPhoneNumber',
        globalMessages.form.invalidPhoneNumber,
        (value, context) => {
          const { phoneCountryCode } = context.parent;

          return value ? isValidPhoneNumber(value, phoneCountryCode) : true;
        },
      ),
    address: Yup.string()
      .required(globalMessages.form.required)
      .test('is-address', globalMessages.form.invalidAddress, (value) => {
        return isAddress(value);
      }),
    postalCode: Yup.string()
      .required(globalMessages.form.required)
      .when(
        'countryCode',
        ([countryCode]: AutocompleteOption[], schema: Yup.StringSchema) => {
          const countryCodeValue = countryCode?.value || '';

          return schema.test(
            'test-postal-code',
            globalMessages.form.invalidPostalCode,
            (postalCode): boolean => {
              if (
                postalCode &&
                countryCodeValue?.toUpperCase() === COUNTRY_CODES.NL
              ) {
                return /^\d{4}\s?[A-Z]{2}$/i.test(postalCode);
              }

              try {
                return (
                  !countryCodeValue ||
                  !postalCode ||
                  isPostalCode(
                    postalCode,
                    countryCodeValue.toUpperCase() as any,
                  )
                );
              } catch (error) {
                logError(error);

                return true;
              }
            },
          );
        },
      ),
    city: Yup.string().required(globalMessages.form.required),
    countryCode: Yup.object()
      .test(
        'countryCode',
        globalMessages.form.required,
        function test(option: UnknownOption) {
          return Boolean(option?.value);
        },
      )
      .required(globalMessages.form.required),
    cgv: Yup.boolean().test('isCgvAccepted', messages.cgvRequired, (value) => {
      if (!value) {
        return false;
      }

      return value;
    }),
  });
};

export default OnboardingFormSchema;
